var gtg_modal, setSiteCookies;

setSiteCookies = require('../../../../core/frontend/groupon_modules/setSiteCookies');


/*
 *  LS-2476 / LS-2480 - GTG (GrouponToGo) modal shared code across desktop / touch / m2016
 */

gtg_modal = (function() {
  return {
    init: function() {
      var $html, $modal, $modalAndWrapper, $picture, $wrapper, highres, lowres, ref;
      if ((typeof localStorage !== "undefined" && localStorage !== null ? localStorage.getItem('gtg_modal') : void 0) || Cookie.get('gtg_modal')) {
        return;
      }
      if (!($modal = $('#ls-gtg-modal')).length) {
        return;
      }
      $wrapper = $('#ls-modals-wrapper');
      $html = $('html');
      $modalAndWrapper = $wrapper.add($modal);
      $picture = $modal.find('#ls-gtg-image');
      ref = $picture.data(), lowres = ref.lowres, highres = ref.highres;
      $picture.prepend("<source media='(min-width: 600px)' srcset='" + highres + "'>");
      $picture.find('img').one('load', function() {
        $modalAndWrapper.removeClass('ls-hide');
        return $html.addClass('blockContentScrolling');
      }).attr('src', lowres);
      $modal.on('click', function(e) {
        e.preventDefault();
        return e.stopImmediatePropagation();
      });
      return $wrapper.add('.ls-gtg-content a').one('click', function(e) {
        $modal.off('click');
        e.stopImmediatePropagation();
        if (localStorage) {
          if (typeof localStorage !== "undefined" && localStorage !== null) {
            localStorage.setItem('gtg_modal', true);
          }
        } else {
          setSiteCookies({
            gtg_modal: true
          }, 60 * 60 * 24 * 30);
        }
        $modalAndWrapper.addClass('ls-hide');
        return $html.removeClass('blockContentScrolling');
      });
    }
  };
})();

module.exports = gtg_modal;

//# sourceMappingURL=data:application/json;base64,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
